jQuery(document).ready(() => {


	/**
	 * Accordion for section { Quienes Somos }
	 */

	const items = jQuery(`[data-nosotros='list-quienes-somos']`);

	items.each(function () {

		jQuery(this).click(() => {

			jQuery(this).siblings('ul').slideToggle();
			jQuery(this).toggleClass('active');

			if (jQuery(this).children('i').hasClass('icon-icon-chevron-down')) {
				jQuery(this).children('i').addClass('icon-icon-chevron-up');
				jQuery(this).children('i').removeClass('icon-icon-chevron-down');
			} else {
				jQuery(this).children('i').removeClass('icon-icon-chevron-up');
				jQuery(this).children('i').addClass('icon-icon-chevron-down');
			}

		});

	});

});